import { ComponentPropsWithoutRef } from "react";

export const LeftArrowIcon = ({
  ...props
}: ComponentPropsWithoutRef<"svg">) => {
  return (
    <svg {...props} viewBox="0 0 14 14">
      <path
        d="M8.75 11.185a.74.74 0 0 1-.53-.22l-3.5-3.5a.75.75 0 0 1 0-1.06l3.5-3.47a.75.75 0 0 1 1.06 1l-3 3 3 3a.75.75 0 0 1 0 1.06.74.74 0 0 1-.53.19Z"
        fill="currentColor"
      />
    </svg>
  );
};
